import React, { FC } from "react";

// component
import { StockSummaryTable } from "./table/StockSummaryTable";
import { LoadingComponent } from "../../../components/common/Loading";
import { ErrorComponent } from "../../../components/common/ErrorComponent";

// custom hook
import { useFetchData } from "../../../hooks/UseFetchData";

// api
import { DashboardAPI } from "../../../../api/dashboard/dashboardAPI";

const dashboard = new DashboardAPI();


export const StockSummary: FC = () => {

  // stock summary data fetch
  const [responce, loading, error] = useFetchData(
    dashboard.getMonthWiseOrder);

  const data = Array.isArray(responce?.data?.data) ? responce?.data?.data : [];

  if (loading) {
    return <LoadingComponent />;
  }

  if (error) {
    return <ErrorComponent message={error} />;
  }

  return (
    <div className="mt-5">
      <StockSummaryTable data={data} />
    </div>
  );
};
